import type React from "react"
import ReactDOM from "react-dom/client"
import UserReviewsModule from "../components/user-reviews-module"
import UserReviewsShadowRoot from "@/components/user-review-shadow-root"

// For standalone webpack build
const App: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <UserReviewsShadowRoot />
    </div>
  )
}

// Mount the app when DOM is ready
if (typeof document !== "undefined") {
  const container = document.getElementById("user-reviews-root")
  if (container) {
    const root = ReactDOM.createRoot(container)
    root.render(<App />)
  }
}

// Export for library usage
export default UserReviewsModule
export { UserReviewsModule }

// Export additional components for advanced usage
export { ReviewCard } from "../components/review-card"
export { ReviewForm } from "../components/review-form"
export { ReviewCarousel } from "../components/review-carousel"
export { VerificationInfo } from "../components/verification-info"

// Export types
export type { Review, NewReviewForm } from "../types/review"

// Export hooks
export { useReviews } from "../hooks/use-reviews"
export { useTranslations } from "../hooks/use-translations"
export { useLocale } from "../hooks/use-locale"

// Export services
export { wordpressApi } from "../services/wordpress-api"
